import {
  CookiePolicyContent,
  sharedContact,
  sharedSections,
} from './cookie-policy-shared.constants'

export const cookiePolicyContent: CookiePolicyContent = {
  title: 'Cookie Policy for Merchandising Management Portal (MMP)',
  introduction:
    'This policy sets out information about Travelport\'s ("<strong>We</strong>" or "<strong>us</strong>" in this policy) use of cookies on our website at \'mmp.travelport.com\' (the "<strong>Website</strong>"). It explains what cookies are and why we use them, as well as your rights to control our use of them.',
  sections: [
    sharedSections.whatIsACookie,
    sharedSections.whatCookiesDoesTPUse,
    sharedSections.howToManageCookies,
    sharedSections.removingCookies,
    sharedSections.blockingCookies,
    {
      title: 'How long will cookies stay on my device?',
      paragraphs: [
        'The length of time a cookie will stay on your computer or mobile device depends on whether it is a "persistent" or "session" cookie. <strong>Persistent cookies</strong> are cookies saved on your computer that are not deleted automatically when you quit your browser, unlike a <strong>session cookie</strong>, which is deleted when you quit your browser. For each of the cookies used on our Website we have set out the duration in the tables below.',
      ],
    },
    {
      title: 'Cookies used by the Website',
      paragraphs: [
        'The specific types of first and third-party cookies used by our Website, their duration and the purposes they perform are described in the tables below:',
      ],
      showOneTrustList: true,
    },
    sharedSections.updatesToPolicy,
  ],
  contact: sharedContact,
}
